
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/best-quran-apps-for-iphone-ipad",
      function () {
        return require("private-next-pages/articles/best-quran-apps-for-iphone-ipad.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/best-quran-apps-for-iphone-ipad"])
      });
    }
  